import { makeStyles } from 'tss-react/mui';

export const useHelpCenterStyles = makeStyles()((theme) => ({
  helpCenterContainer: {
    paddingTop: theme.spacing(4),
    paddingBottom: theme.spacing(10),
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(5),
  },
  // ── Page Header ──
  pageHeader: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(1),
  },
  pageTitle: {
    color: theme.palette.darkSlate.main,
  },
  // ── Helpful Links ──
  sectionHeading: {
    marginBottom: theme.spacing(2.5),
  },
  tileCard: {
    border: `1px solid ${theme.palette.primary.background}`,
    borderRadius: theme.shape.borderRadius,
    boxShadow: '0px 4px 14px 0px rgba(0,0,0,0.05)',
    height: '100%',
  },
  tileAction: {
    height: '100%',
    padding: '28px 28px 24px',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    [theme.breakpoints.down('sm')]: {
      flexDirection: 'row',
      alignItems: 'center',
      padding: theme.spacing(2, 2.5),
      gap: theme.spacing(2),
    },
  },
  tileIconBox: {
    backgroundColor: theme.palette.primary.background,
    borderRadius: theme.shape.borderRadius,
    padding: theme.spacing(1.25),
    display: 'flex',
    flexShrink: 0,
    marginBottom: theme.spacing(1.75),
    [theme.breakpoints.down('sm')]: {
      marginBottom: 0,
    },
  },
  tileTitle: {
    marginBottom: theme.spacing(0.75),
  },
  tileDescription: {
    flexGrow: 1,
  },
  viewLink: {
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(0.5),
    paddingTop: theme.spacing(1.75),
    [theme.breakpoints.down('sm')]: {
      display: 'none',
    },
  },
  viewLinkIcon: {
    fontSize: '14px !important',
  },
  mobileChevron: {
    display: 'none',
    marginLeft: 'auto',
    color: theme.palette.secondary.main,
    [theme.breakpoints.down('sm')]: {
      display: 'block',
    },
  },
  // ── Browse Banner ──
  bannerInner: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    padding: '24px 32px',
    [theme.breakpoints.down('sm')]: {
      padding: theme.spacing(2, 2.5),
    },
  },
  bannerLinkLabel: {
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(0.75),
  },
  // ── Contact Cards ──
  contactCard: {
    border: `1px solid ${theme.palette.divider}`,
    borderRadius: theme.shape.borderRadius,
    boxShadow: 'none',
    padding: '26px 28px',
    height: '100%',
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(1),
  },
  contactCardTitle: {
    fontWeight: 600,
    marginBottom: theme.spacing(0.5),
  },
  submitButtonRow: {
    marginTop: theme.spacing(1.5),
  },
}));

export const useSupportPageStyles = makeStyles()((theme) => ({
  container: {
    paddingTop: theme.spacing(4),
  },
  grid: {
    [theme.breakpoints.up('md')]: {
      flexWrap: 'nowrap',
    },
    '& > div:first-of-type': {
      marginRight: theme.spacing(3),
      [theme.breakpoints.down('md')]: {
        marginRight: 0,
        marginBottom: theme.spacing(3),
      }
    },
    marginBottom: theme.spacing(15),
    [theme.breakpoints.down('md')]: {
      marginBottom: theme.spacing(12),
    }
  },
  gridItem: {
    display: 'flex',
    flexDirection: 'column',
    gap: '21px',
    width: '100%',
    '&:last-of-type': {
      minWidth: '328px',
      [theme.breakpoints.up('md')]: {
        maxWidth: '328px',
      }
    },
    '&:first-of-type': {
      minWidth: '343px',
      [theme.breakpoints.up('md')]: {
        maxWidth: '592px'
      }
    },
  },
  cardTitle: {
    fontWeight: 700,
  },
  cardLeft: {
    padding: '32px',
    [theme.breakpoints.down('md')]: {
      padding: '24px',
    },
  },
  cardRight: {
    minWidth: '343px',
    padding: '32px',
    [theme.breakpoints.down('md')]: {
      padding: '32px 24px',
    },
  },
  supportNumber: {
    fontSize: '24px'
  },
  h3Heading: {
    display: 'block',
    marginBottom: theme.spacing(3),
    color: theme.palette.secondary.main,
    fontSize: '34px'
  },
  footer: {
    '& a': {
      color: theme.palette.text.secondary
    }
  }
}));
